import { IUser } from '@reverbdotcom/commons';
import experiments from '@reverbdotcom/commons/src/experiments';
import { CoreMarketplaceCombinedMarketplaceSearch } from '../../schemas/rql';
import { MOBILE_PHONE } from '@reverbdotcom/commons/src/constants';

export const ALWAYS_TRACKED_EXPERIMENTS = [
  experiments.LISTING_CARD_LOCATION,
  experiments.DUMMY,
  experiments.MARKETPLACE_GRID_ADS,
  experiments.LISTINGS_QUERY_REWRITE_V2,
  experiments.LISTINGS_SEARCH_BEST_MATCH_SIGNALS_V3,
  experiments.LISTINGS_SEARCH_LIKELIHOOD_TO_SELL_V2,
  experiments.LTS_V2_MARKETPLACE,
  experiments.LTS_V2_BRAND,
  experiments.AA_MARKETPLACE_SESSION_BUCKETING,
  experiments.MARKETPLACE_TOTAL_PRICE_FILTER_SORT,
  experiments.SELL_YOURS_SOLD_LISTINGS_SEARCH,
];

export function pageViewTrackedExperiments(
  listingsSearchResult: CoreMarketplaceCombinedMarketplaceSearch.ListingsSearch,
  isListViewEnabled: boolean,
  user: IUser,
): string[] {

  // Experiments that are always tracked in page view events
  const trackedExperiments = [].concat(ALWAYS_TRACKED_EXPERIMENTS);

  // Experiments that are conditionally tracked
  if (listingsSearchResult?.eligibleAutodirects?.length > 0) {
    trackedExperiments.push(experiments.DATA_DRIVEN_AUTODIRECTS);
  }

  if (isListViewEnabled && user.deviceName === MOBILE_PHONE) {
    trackedExperiments.push(experiments.WATCH_BUTTON_SEARCH_LIST_VIEW);
  }

  return trackedExperiments;
}
